import React, { useRef, useEffect, useState, useCallback, useContext } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import '../layout/sass/_pickListSugestoes.scss';

import '../layout/sass/_responsiveTable.scss';
import { confirmDialog } from 'primereact/confirmdialog';
import api from '../api/api';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { BrCalendar } from './BrCalendar';
import pdfMake from 'pdfmake/build/pdfmake';
import "pdfmake/build/vfs_fonts";

import LogoAgricultura from '../assets/Logo_Agricultura.png';
import LogoIEF from '../assets/Logo_IEF.png';

export const TabelaCampanha = () => {
    const history = useHistory();
    const toast = useRef(null);
    const { user } = useContext(AuthContext);
    const [dt, setDt] = useState(null);
    const [campanha, setCampanha] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const confirmationToast = useRef(null);
    const [sortable, setSortable] = useState('ASC');
    const [first, setFirst] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [sortableCampo, setSortableCampo] = useState('nome');
    const [selectedDataInicio, setSelectedDataInicio] = useState(null);
    const [selectedDataFim, setSelectedDataFim] = useState(null);
    const [selectedDataEntrega, setSelectedDataEntrega] = useState(null);
    const [lazyParams, setLazyParams] = useState({
        first: 0,
        rows: 20,
        sortField: null,
        sortOrder: null,
        filters: {
            'nome': { value: "", matchMode: 'contains' },
        }
    });

    const handleLimparClick = () => {
        setLazyParams({
            first: 0,
            rows: 20,
            sortField: null,
            sortOrder: null,
            filters: {
            },
        });
        setSelectedDataInicio(null);
        setSelectedDataFim(null);
        setSelectedDataEntrega(null);
    };

    const header = (
        <div className="p-grid p-col-12 p-m-0 p-p-0">
            <div>
                <h2 className="p-my-0">Campanha</h2>
            </div>
            <div className="p-my-0 p-grid p-dir-rev p-col">
                <div className="p-m-2">
                    <Button
                        label="Adicionar..."
                        className="p-mb-2 p-button-primary"
                        icon="pi pi-plus"
                        iconPos="left"
                        type="button"
                        onClick={() => history.push('/campanhacreate')}
                    />
                </div>
            </div>
        </div>
    );

    const getCampanha = useCallback(async (event) => {
        setIsLoading(true);
        setCampanha([]);

        if (event !== undefined) {
            setTimeout(() => {
                const startIndex = event.first;
                setFirst(startIndex);
            }, 250);
        }

        try {
            if (lazyParams.filters === undefined) {

                if (event === undefined) {
                    const response = await api.get(`campanha?sort=${sortableCampo},${sortable}`);

                    response.data.content.forEach(campanha => {
                        setCampanha(campanhas => [...campanhas, campanha]);
                    });
                } else {
                    const response = await api.get(`campanha?page=${event.page}&sort=${sortableCampo},${sortable}`);
                    response.data.content.forEach(campanha => {
                        setCampanha(campanhas => [...campanhas, campanha]);
                    });
                }

                const respElements = await api.get(`campanha?sort=${sortableCampo},${sortable}`);
                setTotalRecords(respElements.data.totalElements);

            } else {
                const pesquisa = {
                    "id": lazyParams.filters['id'] !== undefined ? lazyParams.filters['id'].value : null,
                    "nome": lazyParams.filters['nome'] !== undefined ? lazyParams.filters['nome'].value : "",
                    "dataInicio": lazyParams.filters['dataInicio'] !== undefined ? lazyParams.filters['dataInicio'].value.replace('Z', '+00:00') : null,
                    "dataFim": lazyParams.filters['dataFim'] !== undefined ? lazyParams.filters['dataFim'].value.replace('Z', '+00:00') : null,
                    "dataEntrega": lazyParams.filters['dataEntrega'] !== undefined ? lazyParams.filters['dataEntrega'].value.replace('Z', '+00:00') : null,
                    "endereco": lazyParams.filters['endereco'] !== undefined ? lazyParams.filter['endereco'].value : ""
                };
                if (event === undefined) {
                    const respElements = await api.post(`campanha/searchCampanha/${sortable}/${sortableCampo}?`, pesquisa);
                    respElements.data.content.forEach(campanha => {
                        setCampanha(campanhas => [...campanhas, campanha]);
                    });
                    setTotalRecords(respElements.data.totalElements);
                } else {
                    const respElements = await api.post(`campanha/searchCampanha/${sortable}/${sortableCampo}?page=${event.page}`, pesquisa);
                    respElements.data.content.forEach(campanha => {
                        setCampanha(campanhas => [...campanhas, campanha]);
                    });
                    setTotalRecords(respElements.data.totalElements);
                }
            }
        }
        catch (error) {
            if (lazyParams !== undefined) {
                if (event === undefined) {
                    const response = await api.get(`campanha?sort=nome,${sortable}`);
                    response.data.content.forEach(campanha => {
                        setCampanha(campanhas => [...campanhas, campanha]);
                    });
                } else {
                    const response = await api.get(`campanha?page=${event.page}&sort=nome,${sortable}`);
                    response.data.content.forEach(campanha => {
                        setCampanha(campanhas => [...campanhas, campanha]);
                    });
                }

                const respElements = await api.get(`campanha?sort=id,${sortable}`);
                setTotalRecords(respElements.data.totalElements);
            } else {
                toast.current.show({ severity: 'error', summary: 'Erro ao obter campanha', detail: error.toString() });
            }
        }

        setIsLoading(false);
    }, [lazyParams, sortable, sortableCampo]);

    useEffect(() => {
        const fetchcampanha = async () => {
            try {
                await getCampanha();
            }
            catch (error) {
                toast.current.show({ severity: 'error', summary: 'Erro ', detail: error.toString() });
            }
        };
        fetchcampanha();

    }, [getCampanha]);

    const idBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Código</span>
                    <span className="table-data">{rowData.id}</span>
                </p>
            </React.Fragment>
        );
    };

    const nomeBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Nome</span>
                    <span className="table-data">{rowData.nome}</span>
                </p>
            </React.Fragment>
        );
    };

    const dataInicioBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Inicio</span>
                    <span className="table-data">
                        {rowData.dataInicio ? new Date(rowData.dataInicio).toLocaleString('pt-BR') : ""}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const dataFimBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Fim</span>
                    <span className="table-data">
                        {rowData.dataFim ? new Date(rowData.dataFim).toLocaleString('pt-BR') : ""}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const dataEntregaBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Data Entrega</span>
                    <span className="table-data">
                        {rowData.dataEntrega ? new Date(rowData.dataEntrega).toLocaleString('pt-BR') : ""}
                    </span>
                </p>
            </React.Fragment>
        );
    };

    const enderecoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Endereço</span>
                    <span className="table-data">{rowData.endereco}</span>
                </p>
            </React.Fragment>
        );
    };

    const ativoBodyTemplate = (rowData) => {
        return (
            <React.Fragment>
                <p style={{ textalign: 'left' }}>
                    <span className="p-column-title">Ativo</span>
                    <span className="table-data">{rowData.ativo === true ? "SIM" : "NÃO"}</span>
                </p>
            </React.Fragment>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button 
                    icon="pi pi-print" 
                    className="p-button-rounded p-mr-2 edit-btn" 
                    title="Relatório por Muda (Com Solicitantes)"
                    onClick={() => generatePDF(rowData, true)} 
                />
                <Button 
                    icon="pi pi-list" 
                    className="p-button-rounded p-button-secondary p-mr-2" 
                    title="Relatório por Muda (Resumido / Sem Solicitantes)"
                    onClick={() => generatePDF(rowData, false)} 
                />
                <Button 
                    icon="pi pi-users" 
                    className="p-button-rounded p-button-info p-mr-2" 
                    title="Relatório por Solicitante (Com Detalhes das Mudas)"
                    onClick={() => generatePDFPorSolicitante(rowData, true)} 
                />
                <Button 
                    icon="pi pi-user" 
                    className="p-button-rounded p-button-help p-mr-2" 
                    title="Relatório por Solicitante (Resumido / Apenas Totais)"
                    onClick={() => generatePDFPorSolicitante(rowData, false)} 
                />
                <Button 
                    icon="pi pi-pencil" 
                    className="p-button-rounded p-mr-2 edit-btn" 
                    onClick={() => handleEditClick(rowData)} 
                />
                <Button 
                    icon="pi pi-trash" 
                    className="p-button-rounded p-mr-2 p-button-danger" 
                    loading={isDeleting} 
                    onClick={() => handleDeleteClick(rowData)} 
                />
            </div>
        );
    };

    const onSort = (event) => {
        setSortableCampo(event.sortField);
        if (sortable === 'ASC') {
            setSortable('DESC');
        } else if (sortable === 'DESC') {
            setSortable('ASC');
        }
    };

    const handleEditClick = (data) => {
        history.push(`/campanha/edit/${data.id}`);
    };

    const handleDeleteClick = (data) => {
        data['userEmail'] = user.email;

        confirmDialog({
            message: `Você tem certeza que quer remover ${data.nome}?`,
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: async () => {
                setIsDeleting(true);

                try {
                    await api.delete(`campanha/${data.id}`);
                    toast.current.show({ life: 5000, severity: 'success', summary: 'Remoção concluída!', detail: `${data.nome} removido(a) com sucesso` });
                    getCampanha();
                }
                catch (error) {
                    toast.current.show({ life: 5000, severity: 'error', summary: 'Erro ao remover a campanha', detail: error.toString() });
                }

                setIsDeleting(false);
            },
            reject: () => { return; }
        });
    };

    const onFilter = (event) => {
        event['first'] = 0;
        setLazyParams(event);
    };

    const onDataInicioSearchChange = (event) => {
        if (event.value !== null) {
            let data = event.value.toISOString();
            dt.filter(data, 'dataInicio', 'equals');
            setSelectedDataInicio(event.value);
        }
        else
            dt.filter(null, 'dataInicio', 'equals');
    };

    const onDataInicioInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'dataInicio', 'equals');
            setSelectedDataInicio(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataInicio', 'equals');
    };

    const onDataFimSearchChange = (event) => {
        if (event.value !== null) {
            let data = event.value.toISOString();
            dt.filter(data, 'dataFim', 'equals');
            setSelectedDataFim(event.value);
        }
        else
            dt.filter(null, 'dataFim', 'equals');
    };

    const onDataFimInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'dataFim', 'equals');
            setSelectedDataFim(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataFim', 'equals');
    };

    const onDataEntregaSearchChange = (event) => {
        if (event.value !== null) {
            let data = event.value.toISOString();
            dt.filter(data, 'dataEntrega', 'equals');
            setSelectedDataEntrega(event.value);
        }
        else
            dt.filter(null, 'dataEntrega', 'equals');
    };

    const onDataEntregaInputChange = (event) => {
        if (event.target.value !== null) {
            let data = new Date(event.target.value.split('/').reverse().join('/')).toISOString();
            dt.filter(data, 'dataEntrega', 'equals');
            setSelectedDataEntrega(new Date(event.target.value.split('/').reverse().join('/')));
        }
        else
            dt.filter(null, 'dataEntrega', 'equals');
    };

    function formatCpf(data) {
        if (!data) return '-';
        const cpf = data.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
        return cpf;
    }

    const loadImage = async (url) => {
        const res = await fetch(url);
        const blob = await res.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    };

    // 1. Relatório por Muda (Com opção de incluir/ocultar solicitantes)
    const generatePDF = async (data, incluirSolicitantes = true) => {
        try {
            const [logoAgri, logoIEF] = await Promise.all([
                loadImage(LogoAgricultura),
                loadImage(LogoIEF)
            ]);

            const response = await api.get(`pessoaMudas/campanha/${data.id}`);
            const mudas = response.data || [];

            if (mudas.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Sem dados',
                    detail: 'Nenhuma muda cadastrada nesta campanha.',
                    life: 3000
                });
                return;
            }

            let totalGeralDisponibilizado = 0;
            let totalGeralSolicitado = 0;

            const relatorio = {
                pageSize: 'A4',
                pageMargins: [40, 30, 40, 40],
                content: [
                    {
                        table: {
                            widths: ['*', '*'],
                            body: [
                                [
                                    { image: logoAgri, width: 140, height: 43 },
                                    { image: logoIEF, width: 140, height: 43, alignment: 'right' }
                                ]
                            ]
                        },
                        layout: 'noBorders',
                        margin: [0, 0, 0, 15]
                    },
                    {
                        text: `RELATÓRIO DE DISTRIBUIÇÃO DE MUDAS (POR ESPÉCIE)`,
                        style: 'mainHeader',
                        alignment: 'center'
                    },
                    {
                        text: `${data.nome || 'Campanha'} | Local: ${data.endereco || '-'} | Data de Entrega: ${data.dataEntrega ? new Date(data.dataEntrega).toLocaleDateString('pt-BR') : '-'}`,
                        style: 'subHeader',
                        alignment: 'center'
                    },
                    { 
                        canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#CCCCCC' }], 
                        margin: [0, 5, 0, 12] 
                    }
                ],
                styles: {
                    mainHeader: { fontSize: 13, bold: true, color: '#2C3E50', letterSpacing: 0.5 },
                    subHeader: { fontSize: 8.5, color: '#555555', margin: [0, 3, 0, 5] },
                    mudaName: { fontSize: 9.5, bold: true, color: '#1E4620' },
                    mudaQtds: { fontSize: 8.5, bold: true, color: '#333333', alignment: 'right' },
                    tableHeader: { bold: true, fontSize: 8.5, color: '#444444' },
                    tableBody: { fontSize: 8.5, color: '#333333' },
                    totalGeralTitle: { fontSize: 10, bold: true, color: '#1B5E20' },
                    totalGeralQtds: { fontSize: 9.5, bold: true, color: '#1B5E20', alignment: 'right' }
                },
            };

            mudas.forEach((muda) => {
                const temSolicitantes = incluirSolicitantes && muda.solicitantes && muda.solicitantes.length > 0;
                const qtdDisponibilizada = muda.quantidadeDisponibilizada ?? 0;
                const qtdSolicitada = muda.quantidadeTotalSolicitada || 0;

                totalGeralDisponibilizado += qtdDisponibilizada;
                totalGeralSolicitado += qtdSolicitada;

                const headerRow = [
                    { 
                        text: `• ${muda.nomeMuda?.toUpperCase() || 'SEM NOME'}`, 
                        style: 'mudaName',
                        border: [false, false, false, temSolicitantes]
                    },
                    { 
                        text: `Disp: ${qtdDisponibilizada}   |   Solicitado: ${qtdSolicitada}`, 
                        style: 'mudaQtds',
                        colSpan: temSolicitantes ? 2 : 1,
                        border: [false, false, false, temSolicitantes]
                    }
                ];

                if (temSolicitantes) {
                    headerRow.push({});
                }

                let tableBody = [headerRow];

                if (temSolicitantes) {
                    tableBody.push([
                        { 
                            text: 'Solicitante', 
                            style: 'tableHeader', 
                            margin: [12, 0, 0, 0], 
                            border: [false, true, false, true], 
                            borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC'] 
                        },
                        { text: 'CPF', style: 'tableHeader', alignment: 'center', border: [false, true, false, true], borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC'] },
                        { text: 'Qtd', style: 'tableHeader', alignment: 'center', border: [false, true, false, true], borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC'] }
                    ]);

                    muda.solicitantes.forEach((sol) => {
                        tableBody.push([
                            { 
                                text: sol.nome || '-', 
                                style: 'tableBody', 
                                margin: [12, 0, 0, 0], 
                                border: [false, false, false, true], 
                                borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'] 
                            },
                            { text: sol.cpf ? formatCpf(sol.cpf) : '-', style: 'tableBody', alignment: 'center', border: [false, false, false, true], borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'] },
                            { text: sol.quantidade || 0, style: 'tableBody', alignment: 'center', border: [false, false, false, true], borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'] }
                        ]);
                    });
                }

                const blocoMuda = {
                    margin: [0, 0, 0, temSolicitantes ? 8 : 4],
                    table: {
                        widths: temSolicitantes ? ['*', 110, 50] : ['*', 160],
                        body: tableBody
                    },
                    layout: {
                        fillColor: (rowIndex) => {
                            if (rowIndex === 0) return '#F4F7F4';
                            return null;
                        }
                    }
                };

                relatorio.content.push(blocoMuda);
            });

            const blocoTotalGeral = {
                margin: [0, 15, 0, 0],
                table: {
                    widths: ['*', 200],
                    body: [
                        [
                            { 
                                text: 'TOTAL GERAL DA CAMPANHA', 
                                style: 'totalGeralTitle',
                                border: [false, true, false, true],
                                borderColor: ['#CCCCCC', '#2E7D32', '#CCCCCC', '#2E7D32']
                            },
                            { 
                                text: `Total Disp: ${totalGeralDisponibilizado}   |   Total Solicitado: ${totalGeralSolicitado}`, 
                                style: 'totalGeralQtds',
                                border: [false, true, false, true],
                                borderColor: ['#CCCCCC', '#2E7D32', '#CCCCCC', '#2E7D32']
                            }
                        ]
                    ]
                },
                layout: {
                    fillColor: () => '#E8F5E9'
                }
            };

            relatorio.content.push(blocoTotalGeral);
            pdfMake.createPdf(relatorio).open();

        } catch (error) {
            console.error('Erro ao gerar relatório:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Falha ao gerar o relatório PDF.',
                life: 4000
            });
        }
    };

    // 2. Relatório por Solicitante (Com opção de incluir/ocultar a lista de mudas)
    const generatePDFPorSolicitante = async (data, incluirMudas = true) => {
        try {
            const [logoAgri, logoIEF] = await Promise.all([
                loadImage(LogoAgricultura),
                loadImage(LogoIEF)
            ]);

            const response = await api.get(`pessoaMudas/campanha/${data.id}/solicitantes`);
            const solicitantes = response.data || [];

            if (solicitantes.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: 'Sem dados',
                    detail: 'Nenhum solicitante cadastrado nesta campanha.',
                    life: 3000
                });
                return;
            }

            const relatorio = {
                pageSize: 'A4',
                pageMargins: [40, 30, 40, 40],
                content: [
                    {
                        table: {
                            widths: ['*', '*'],
                            body: [
                                [
                                    { image: logoAgri, width: 140, height: 43 },
                                    { image: logoIEF, width: 140, height: 43, alignment: 'right' }
                                ]
                            ]
                        },
                        layout: 'noBorders',
                        margin: [0, 0, 0, 15]
                    },
                    {
                        text: `RELATÓRIO DE SOLICITANTES E MUDAS`,
                        style: 'mainHeader',
                        alignment: 'center'
                    },
                    {
                        text: `${data.nome || 'Campanha'} | Local: ${data.endereco || '-'} | Data de Entrega: ${data.dataEntrega ? new Date(data.dataEntrega).toLocaleDateString('pt-BR') : '-'}`,
                        style: 'subHeader',
                        alignment: 'center'
                    },
                    { 
                        canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1, lineColor: '#CCCCCC' }], 
                        margin: [0, 5, 0, 12] 
                    }
                ],
                styles: {
                    mainHeader: { fontSize: 13, bold: true, color: '#2C3E50', letterSpacing: 0.5 },
                    subHeader: { fontSize: 8.5, color: '#555555', margin: [0, 3, 0, 5] },
                    solicitanteName: { fontSize: 9.5, bold: true, color: '#1E4620' },
                    solicitanteInfo: { fontSize: 8.5, bold: true, color: '#333333', alignment: 'right' },
                    tableHeader: { bold: true, fontSize: 8.5, color: '#444444' },
                    tableBody: { fontSize: 8.5, color: '#333333' }
                },
            };

            solicitantes.forEach((sol) => {
                const temMudas = incluirMudas && sol.mudas && sol.mudas.length > 0;
                const totalMudas = sol.quantidadeTotalMudas || 0;

                const headerRow = [
                    { 
                        text: `• ${sol.nomePessoa?.toUpperCase() || 'SEM NOME'} (${formatCpf(sol.cpfPessoa)})`, 
                        style: 'solicitanteName',
                        border: [false, false, false, temMudas]
                    },
                    { 
                        text: `Total de Mudas: ${totalMudas}`, 
                        style: 'solicitanteInfo',
                        border: [false, false, false, temMudas]
                    }
                ];

                let tableBody = [headerRow];

                if (temMudas) {
                    tableBody.push([
                        { 
                            text: 'Muda Solicitada', 
                            style: 'tableHeader', 
                            margin: [12, 0, 0, 0], 
                            border: [false, true, false, true], 
                            borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC'] 
                        },
                        { text: 'Qtd', style: 'tableHeader', alignment: 'center', border: [false, true, false, true], borderColor: ['#CCCCCC', '#CCCCCC', '#CCCCCC', '#CCCCCC'] }
                    ]);

                    sol.mudas.forEach((muda) => {
                        tableBody.push([
                            { 
                                text: muda.nomeMuda || '-', 
                                style: 'tableBody', 
                                margin: [12, 0, 0, 0], 
                                border: [false, false, false, true], 
                                borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'] 
                            },
                            { text: muda.quantidade || 0, style: 'tableBody', alignment: 'center', border: [false, false, false, true], borderColor: ['#F5F5F5', '#F5F5F5', '#F5F5F5', '#F5F5F5'] }
                        ]);
                    });
                }

                const blocoSolicitante = {
                    margin: [0, 0, 0, temMudas ? 8 : 3],
                    table: {
                        widths: ['*', 100],
                        body: tableBody
                    },
                    layout: {
                        fillColor: (rowIndex) => {
                            if (rowIndex === 0) return '#F4F7F4';
                            return null;
                        }
                    }
                };

                relatorio.content.push(blocoSolicitante);
            });

            pdfMake.createPdf(relatorio).open();

        } catch (error) {
            console.error('Erro ao gerar relatório por solicitante:', error);
            toast.current?.show({
                severity: 'error',
                summary: 'Erro',
                detail: 'Falha ao gerar o relatório PDF por solicitante.',
                life: 4000
            });
        }
    };

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-p-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <Toast ref={confirmationToast} position="bottom-center" />

                <div className="card p-col-12 datatable-responsive-demo">
                    <div className="p-fluid">
                        <DataTable
                            totalRecords={totalRecords}
                            lazy="true"
                            first={first}
                            onPage={getCampanha}
                            ref={(element) => setDt(element)}
                            header={header}
                            value={campanha}
                            filterDisplay="row"
                            className="p-datatable-responsive-demo"
                            emptyMessage="Nenhuma campanha encontrada"
                            loading={isLoading}
                            dataKey="id"
                            paginator
                            rows={20}
                            currentPageReportTemplate={`Mostrando de {first} a {last} de ${totalRecords} campanha`}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            rowsPerPageOptions={[20, 100]}
                            onSort={onSort}
                            onFilter={onFilter}
                            filters={lazyParams.filters}
                        >
                            <Column
                                field="id"
                                header="Código"
                                sortable
                                body={idBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Código"
                            />

                            <Column
                                field="nome"
                                header="Nome"
                                sortable
                                body={nomeBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Nome"
                            />

                            <Column
                                field="dataInicio"
                                header="Data Inicio"
                                sortable={sortable}
                                body={dataInicioBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataInicio}
                                        id="data"
                                        name="data"
                                        value={selectedDataInicio}
                                        showTime={true}
                                        hourFormat="24"
                                        onSelect={(e) => onDataInicioSearchChange(e)}
                                        onInput={(e) => onDataInicioInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 3}`}
                                        placeholder="Selecione data e hora"
                                        onClearButtonClick={() => handleLimparClick()}
                                    />
                                }
                            />

                            <Column
                                field="dataFim"
                                header="Data Fim"
                                sortable={sortable}
                                body={dataFimBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataFim}
                                        id="data"
                                        name="data"
                                        value={selectedDataFim}
                                        showTime={true}
                                        hourFormat="24"
                                        onSelect={(e) => onDataFimSearchChange(e)}
                                        onInput={(e) => onDataFimInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 3}`}
                                        placeholder="Selecione data e hora"
                                        onClearButtonClick={() => handleLimparClick()}
                                    />
                                }
                            />

                            <Column
                                field="dataEntrega"
                                header="Data Entrega"
                                sortable={sortable}
                                body={dataEntregaBodyTemplate}
                                filter
                                filterElement={
                                    <BrCalendar
                                        key={selectedDataEntrega}
                                        id="data"
                                        name="data"
                                        value={selectedDataEntrega}
                                        showTime={true}
                                        hourFormat="24"
                                        onSelect={(e) => onDataEntregaSearchChange(e)}
                                        onInput={(e) => onDataEntregaInputChange(e)}
                                        yearRange={`2000:${new Date().getFullYear() + 3}`}
                                        placeholder="Selecione data e hora"
                                        onClearButtonClick={() => handleLimparClick()}
                                    />
                                }
                            />

                            <Column
                                field="endereco"
                                header="Endereco"
                                sortable
                                body={enderecoBodyTemplate}
                                lazyParams
                                filter
                                filterMatchMode="contains"
                                filterPlaceholder="Pesquisar por Endereço"
                            />

                            <Column
                                field="ativo"
                                header="Ativo"
                                sortable
                                body={ativoBodyTemplate}
                                lazyParams
                            />

                            <Column
                                header="Ações"
                                body={actionBodyTemplate}
                            />
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
};